import { useCustomerGroup } from '../context';
import {
	setSelectedMake,
	setSelectedModel,
	setSelectedSubModel,
	setSelectedYear,
} from '../store/productsSearchSlices/vehicleFiltersSlice';
import { FilterSelect } from './FilterSelect';

export function VehicleSelection({ vehiclesState, updateSelection }) {
	const [customerGroup] = useCustomerGroup();

	return (
		<>
			<FilterSelect
				onOptionChange={(data) =>
					updateSelection(setSelectedYear(data))
				}
				placeholder="Year"
				value={vehiclesState.year.selected}
				options={vehiclesState.year.options}
				required={true}
				filterable={true}
				disabled={!customerGroup}
			/>
			<FilterSelect
				onOptionChange={(data) =>
					updateSelection(setSelectedMake(data))
				}
				placeholder="Make"
				value={vehiclesState.make.selected}
				options={vehiclesState.make.options}
				required={true}
				filterable={true}
				disabled={vehiclesState.make.options.length === 0}
			/>
			<FilterSelect
				onOptionChange={(data) =>
					updateSelection(setSelectedModel(data))
				}
				placeholder="Model"
				value={vehiclesState.model.selected}
				options={vehiclesState.model.options}
				required={true}
				filterable={true}
				disabled={vehiclesState.model.options.length === 0}
			/>
			{vehiclesState.subModel.options.length > 0 && (
				<FilterSelect
					onOptionChange={(data) =>
						updateSelection(setSelectedSubModel(data))
					}
					placeholder="Sub Model"
					value={vehiclesState.subModel.selected}
					options={vehiclesState.subModel.options}
					required={true}
					filterable={true}
					disabled={!customerGroup}
				/>
			)}
		</>
	);
}
